import request from "utils/request";
const state = {
  collegeData: "",
  currentMajor: "",
  relativeList: [
    {
      title: "岗位发展路径",
      id: "JobGrowthPath",
      pic: "/img/major-path-nor.png",
      link: "/feature/major/relative/JobGrowthPath"
    },
    {
      title: "就业前景及方向",
      id: "JobProspect",
      pic: "/img/major-prospect-nor.png",
      link: "/feature/major/relative/JobProspect"
    },
    {
      title: "专业平台及实践",
      id: "PracticePlatform",
      pic: "/img/major-platform-nor.png",
      link: "/feature/major/relative/PracticePlatform"
    },
    {
      title: "教学资源",
      id: "materials",
      pic: "/img/major-material-nor.png",
      link: "/feature/major/materials"
    }
  ],
  councilInfoList: [
    {
      title: "理事会架构",
      id: "Structure",
      link: "/feature/council/info/Structure"
    },
    {
      title: "理事会成员",
      id: "Member",
      link: "/feature/council/info/Member"
    },
    {
      title: "理事会章程",
      id: "Constitution",
      link: "/feature/council/info/Constitution"
    },
    {
      title: "理事会风采",
      id: "Shows",
      link: "/feature/council/list"
    }
  ]
  // collegeData: JSON.parse(sessionStorage.getItem('collegeData')) || '',
};

const actions = {
  async setCollegeData({ commit }) {
    // 这种解析路由的方式  会导致路由中添加参数的时候 会解析不到当前产业学院的 path
    // let url = window.location.href.replace(
    //   /feature-(\S+?)\/(.*)*$/,
    //   "feature-$1"
    // );
    // const myUrl = url.split("/");
    // var collegeUrl = myUrl[myUrl.length - 1];

    let url = window.location.pathname;
    const myUrl = url.split("/");
    let collegeUrl = myUrl[1];

    //改变link
    var temprelativeList = state.relativeList;
    temprelativeList.forEach(o => {
      if (!o.link.includes("-")) {
        o.link = o.link.replace("feature", collegeUrl);
      }
    });
    state.relativeList = temprelativeList;
    var tempcouncilInfoList = state.councilInfoList;
    tempcouncilInfoList.forEach(o => {
      if (!o.link.includes("-")) {
        o.link = o.link.replace("feature", collegeUrl);
      }
    });
    state.councilInfoList = tempcouncilInfoList;

    //获取路由中产业学院的参数 例如 feature-tdgc
    const params = { url: myUrl[1] };
    const res = await request({
      url: "/Business/GetCollegeData",
      method: "get",
      params: params
    });

    commit("SET_VALUE", {
      key: "collegeData",
      value: res.Result
    });
    // sessionStorage.setItem('collegeData', JSON.stringify(res.Result))
    return res;
  },
  setCurrenMajor({ commit }, major) {
    commit("SET_VALUE", {
      key: "currentMajor",
      value: major
    });
  }
};

const mutations = {
  SET_VALUE(state, params) {
    state[params.key] = params.value;
  }
};

const getters = {
  get(state) {
    return state.menuList;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
